export default {
  outcomes: [],
  autocomplete_data : [],
  autocomplete_selected : {},
  outcome:[],
  selected_outcome : {},
  outcome_status:[]
}
